import { useCallback, useContext } from "react";
import {
  Board,
  BoardMachinesStates,
  physicalDetailsLoaded,
  updatePhysicalDetailsState,
} from "../../../../../reducers/uploadedBoard";
import {
  getPhysicalDetailsRefreshAction,
  PhysicalDetailsRefreshAction,
} from "./physicalDetailsRefresh";
import { useRefreshBoardInStore } from "../boardRefreshes";
import { useAppDispatch } from "../../../store";
import { useDebouncedCallback } from "use-debounce";
import { BoardIdContext, BoardShipmentIds } from "./reviewBoardFlowLoader";

export default function useRefreshPhysicalDetails() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const dispatch = useAppDispatch();

  const updatePhysicalDetails = useCallback(
    (board: Board) => {
      dispatch(physicalDetailsLoaded({ board }));
    },
    [dispatch],
  );
  const { refreshBoard: refreshPhysicalDetails } = useRefreshBoardInStore(
    updatePhysicalDetails,
  );

  const debouncedRefreshPhysicalDetails = useDebouncedCallback(
    refreshPhysicalDetails,
    10000,
    { leading: true },
  );

  const handlePhysicalDetailsStateUpdates = useCallback(
    (nextStatesData: BoardMachinesStates, states: BoardMachinesStates) => {
      const action = getPhysicalDetailsRefreshAction(nextStatesData, states);
      if (action === PhysicalDetailsRefreshAction.REFRESH) {
        refreshPhysicalDetails();
      } else if (action === PhysicalDetailsRefreshAction.DEBOUNCED_REFRESH) {
        debouncedRefreshPhysicalDetails();
      } else if (boardId) {
        dispatch(
          updatePhysicalDetailsState({
            boardId,
            physicalDetailsState: nextStatesData.physical_details_state,
          }),
        );
      }
    },
    [
      debouncedRefreshPhysicalDetails,
      dispatch,
      refreshPhysicalDetails,
      boardId,
    ],
  );

  return { handlePhysicalDetailsStateUpdates };
}
